import { getRBPStringId } from '../../../page/main/main-page-states';
import http, { BASE_URL_2, BASE_URL_2_5, BASE_URL_3, BASE_URL_3_0 } from '../../http';

const printSettingApi = {

    /**
     * 获取打印机
     */
    async getPrintersDevice(): Promise<any> {
        return await http.get(`${BASE_URL_2}/printers/location/${getRBPStringId()}`)
    },
    /**
     * 获取打印队列
     */
    async getPrintersQueue(): Promise<any> {
        return await http.get(`${BASE_URL_2_5}/printer-queue/${getRBPStringId()}`)
    },
    /**
     * 删除打印队列
     */
    async delPrintersQueue(printId: string[]): Promise<any> {
        return await http.delete(`${BASE_URL_2_5}/printer-queue${getRBPStringId()}`, {
            data: {
                printId
            }
        })
    },
    /**
     * 测试打印
     */
    async postPrintersTest(params: any): Promise<any> {
        return await http.post(`${BASE_URL_3}/printer/test/ip/${getRBPStringId()}`, params)
    },
    /**
     * 新建打印机设备
     */
    async postPrinterDevice(params: any): Promise<any> {
        return await http.post(`${BASE_URL_3}/print_devices/${getRBPStringId()}`, params)
    },
    /**
     * 获取打印机设备
     */
    async getPrinterDevice(params: any): Promise<any> {
        return await http.get(`${BASE_URL_3}/print_devices/${getRBPStringId()}`, params)
    },
    /**
     * 编辑打印机设备
     */
    async patchPrinterDevice(id: string, params: any): Promise<any> {
        return await http.patch(`${BASE_URL_3}/print_devices/${getRBPStringId()}/${id}`, params)
    },
    /**
     * 删除打印机设备
     */
    async delPrinterDevice(params: any): Promise<any> {
        return await http.delete(`${BASE_URL_3}/print_devices/${getRBPStringId()}`, {
            data: params
        })
    },
    /**
     * 获取打印机头
     */
    async getPrinterHead(): Promise<any> {
        return await http.get(`${BASE_URL_3}/descriptors_headers/${getRBPStringId()}`)
    },
    /**
     * 创建打印机头
     */
    async postPrinterHead(params: any): Promise<any> {
        return await http.post(`${BASE_URL_3}/descriptors_headers/${getRBPStringId()}`, params)
    },
    /**
     * 编辑打印机头
     */
    async patchPrinterHead(id: string, params: any): Promise<any> {
        return await http.patch(`${BASE_URL_3}/descriptors_headers/${getRBPStringId()}/${id}`, params)
    },
    /**
     * 删除打印机头
     */
    async delPrinterHead(params: any): Promise<any> {
        return await http.delete(`${BASE_URL_3}/descriptors_headers/${getRBPStringId()}`, {
            data: params
        })
    },
    /**
     * 获取打印机尾
     */
    async getPrinterTrailers(): Promise<any> {
        return await http.get(`${BASE_URL_3}/descriptors_trailers/${getRBPStringId()}`)
    },
    /**
     * 创建打印机尾
     */
    async postPrinterTrailers(params: any): Promise<any> {
        return await http.post(`${BASE_URL_3}/descriptors_trailers/${getRBPStringId()}`, params)
    },
    /**
     * 编辑打印机尾
     */
    async patchPrinterTrailers(id: string, params: any): Promise<any> {
        return await http.patch(`${BASE_URL_3}/descriptors_trailers/${id}/${getRBPStringId()}`, params)
    },
    /**
     * 删除打印机尾
     */
    async delPrinterTrailers(params: any): Promise<any> {
        return await http.delete(`${BASE_URL_3}/descriptors_trailers/${getRBPStringId()}`, {
            data: params
        })
    },
    /**
     * 获取打印机组
     */
    async getPrinterClass(rbpStringId?: string): Promise<any> {
        const sid = (rbpStringId && rbpStringId.trim()) || getRBPStringId();
        return await http.get(`${BASE_URL_3}/print_class/${sid}`)
    },
    /**
     * 创建打印机组
     */
    async postPrinterClass(params: any): Promise<any> {
        return await http.post(`${BASE_URL_3}/print_class/${getRBPStringId()}`, params)
    },
    /**
     * 编辑打印机组
     */
    async patchPrinterClass(id: string, params: any): Promise<any> {
        return await http.patch(`${BASE_URL_3}/print_class/${id}/${getRBPStringId()}`, params)
    },
    /**
     * 删除打印机组
     */
    async delPrinterClass(params: any): Promise<any> {
        return await http.delete(`${BASE_URL_3}/print_class/${getRBPStringId()}`, {
            data: params
        })
    },

    /**
     * 获取打印模板
     */
    async getPrintTemplate(): Promise<any> {
        return await http.get(`${BASE_URL_3}/printer_template/${getRBPStringId()}`)
    },

    /**
     * 获取指定模板的默认内容（与 RBP2 `getDefaultPrintTemplate` 一致，用于恢复默认与字段来源）
     */
    async getDefaultPrintTemplate(template_id: number): Promise<any> {
        return await http.get(`${BASE_URL_3}/restore_default/${getRBPStringId()}`, { params: { template_id } })
    },

    /**
     * 保存打印模板
     */
    async savePrintTemplate(id: number, params: any): Promise<any> {
        return await http.patch(`${BASE_URL_3}/printer_template/${getRBPStringId()}`, params)
    },

    /**
     * 测试打印模板
     */
    async testPrintTemplate(params: any): Promise<any> {
        return await http.post(`${BASE_URL_3}/printer_test/${getRBPStringId()}`, params)
    },

    /**
     * 获取打印队列
     */
    async getPrintQueue(): Promise<any> {
        return await http.get(`${BASE_URL_3_0}/print-queue-data/${getRBPStringId()}`)
    },
    /**
     * 获取打印队列的打印ID
     */
    async postPrintQueue(id: any, params: any): Promise<any> {
        return await http.post(`${BASE_URL_3}/print_status/${id}/${getRBPStringId()}`, params)
    },
    /**
     * 清空打印队列
     */
    async postClearPrintQueue(): Promise<any> {
        return await http.post(`${BASE_URL_3}/print_queue_data/empty${getRBPStringId()}`)
    },

    /**
     * 获取税务打印机列表
     */
    async getFiscalPrinter(): Promise<any> {
        return await http.get(`${BASE_URL_3}/fiscal_printer/${getRBPStringId()}`)
    },

    /**
     * 新增税务打印机
     */
    async postFiscalPrinter(params: any): Promise<any> {
        return await http.post(`${BASE_URL_3}/fiscal_printer/${getRBPStringId()}`, params)
    },

    /**
     * 修改税务打印机
     */
    async patchFiscalPrinter(params: any): Promise<any> {
        return await http.patch(`${BASE_URL_3}/fiscal_printer/${params.fp_id}/${getRBPStringId()}`, Object.assign({}, params, { fp_id: undefined }))
    },

    /**
     * 删除税务打印机
     */
    async delFiscalPrinter(ids: number[]): Promise<any> {
        return await http.delete(`${BASE_URL_3}/fiscal_printer/${getRBPStringId()}`, { data: { ids } })
    },

    /**
     * 测试税务小票
     */
    async testTaxPrint(params: any): Promise<any> {
        return await http.get(`${BASE_URL_3}/fiscal_printer/test/${params.fp_id}/${getRBPStringId()}`, {
            params: Object.assign({}, params, { fp_id: undefined })
        })
    },

    /**
     * 查询税务打印机连接状态
     */
    async checkTaxPrinterStatus(params: any): Promise<any> {
        return await http.get(`${BASE_URL_3}/fiscal_printer/check_status/${params.fp_id}/${getRBPStringId()}`, {
            params: Object.assign({}, params, { fp_id: undefined })
        })
    },
    /**
     * 重启税务打印机
     */
    async restartTaxPrinter(params: any): Promise<any> {
        return await http.patch(`${BASE_URL_3}/fiscal_printer/reset/${params.fp_id}/${getRBPStringId()}`, {
            params: Object.assign({}, params, { fp_id: undefined })
        })
    },

    /**
     * 查询Custom协议类型税务打印机设备信息
     */
    async getCustomFprinterInfo(params: any): Promise<any> {
        return await http.get(`${BASE_URL_3}/custom_fiscal_printer/get_info/${params.fp_id}/${getRBPStringId()}`, {
            params: Object.assign({}, params, { fp_id: undefined })
        });
    },




}
export default printSettingApi;
